import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".section1 .mySwiper2", {
    spaceBetween: '2.14%',
    slidesPerView: 5,
});
var swiper2 = new Swiper(".section1 .mySwiper", {
    navigation: {
        nextEl: ".section1 .swiper-button-next",
        prevEl: ".section1 .swiper-button-prev",
    },
    thumbs: {
        swiper: swiper,
    },
});

            
 var overview = new Swiper(".section3 .swiper", {
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    speed:700,
    loop:true,//必须
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});

 var overview = new Swiper(".section7 .swiper", {
    speed:7000,//匀速时间
    autoplay: {
    	delay: 0,
    	stopOnLastSlide: false,
    	disableOnInteraction: false,
    },
    loop:true,//必须
     breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 5.2,
        spaceBetween: 16,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 4.2,
        spaceBetween: 16,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        spaceBetween: 10,
      }
    } 
});


$(".section6 ul li").eq(0).addClass("active");
$(".section6 .right .pic").eq(0).addClass("active");
$(".section6 ul li").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".section6 .right .pic").eq(index).addClass("active").siblings().removeClass("active");
})